/** Copyright (c) 2020 T.Rowe Price. All rights reserved. */

import './ContentFragment.scss';

import React, { Component } from 'react';
import { isArray } from 'lodash';
import { Spinner } from '@trp-beacon-ui-kit/react-communication';
import { CONTENT_TYPES, extractContentModel } from '../CMSUtils';
import Switch from 'components/shared/Switch/Switch';
import Case from 'components/shared/Switch/Case';

import { aamFetch } from 'services/Rest';

export default class ContentFragment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      hasError: null,
      cmsContent: null
    };
  }

  componentDidMount() {
    const { cmsUrl, contentKey, contentType, dataTransform } = this.props;
    const cmsContent = this.getContentFromCMS(
      cmsUrl,
      contentKey,
      contentType,
      dataTransform
    );

    cmsContent.then((content) => {
      this.setState({
        cmsContent: content
      });
    });
  }

  async getContentFromCMS(cmsURL, contentKey, contentType, dataTransform) {
    const cmsResponse = await aamFetch(cmsURL, null, false);
    if (!cmsResponse) {
      this.setState({ hasError: true });
    }

    return extractContentModel(
      contentType,
      contentKey,
      cmsResponse,
      dataTransform
    );
  }

  render() {
    const { styleIdentifier, contentKey, contentType, CustomComponent } =
      this.props;
    const { isLoading, cmsContent } = this.state;

    if (isLoading) {
      return <Spinner />;
    }
    if (contentType && contentKey) {
      return (
        <Switch test={contentType}>
          <Case value={CONTENT_TYPES.IMAGE}>
            <img
              className={`image ${styleIdentifier}`}
              alt={cmsContent}
              src={cmsContent}
            />
          </Case>
          <Case value={CONTENT_TYPES.TEXT}>
            <div className={`content-text ${styleIdentifier}`}>
              {cmsContent}
            </div>
          </Case>
          <Case value={CONTENT_TYPES.HTML}>
            <div className={`content-html ${styleIdentifier}`}>
              <div dangerouslySetInnerHTML={{ __html: cmsContent }} />
            </div>
          </Case>
          <Case value={CONTENT_TYPES.LIST}>
            <div className={`content-list-container ${styleIdentifier}`}>
              {isArray(cmsContent) ? (
                <ul>
                  {cmsContent.map((listItem) => {
                    <li className={'list-item'}>{listItem}</li>;
                  })}
                </ul>
              ) : null}
            </div>
          </Case>
          <Case value={CONTENT_TYPES.CUSTOM}>
            {CustomComponent ? (
              <CustomComponent className="content-custom">
                {cmsContent}
              </CustomComponent>
            ) : null}
          </Case>
        </Switch>
      );
    }
    return null;
  }
}
